/* ••[1]••••••••••••••••••••••••• testimonialVideoVm.ts •••••••••••••••••••••••••••••• */
import { CustomElement } from "../../core/CustomElement";
import {
  TestimonialVideo,
  validatedTestimonialVideo,
} from "../../core/types/TestimonialVideo";

import ko from "knockout";

export default class TestimonialVideoVm {
  $customElement: CustomElement;
  testimonialVideo: KnockoutObservable<TestimonialVideo>;
  opened: KnockoutObservable<boolean>;
  videoLink: KnockoutComputed<string>;

  constructor($customElement: CustomElement) {
    this.$customElement = $customElement;
    this.testimonialVideo = ko.observable({} as TestimonialVideo);
    this.opened = ko.observable(false);
    this.videoLink = ko.computed(() => {
      if (this.opened()) {
        return this.testimonialVideo().link;
      }

      return "";
    });
  }

  private display(): boolean {
    return !!validatedTestimonialVideo(this.testimonialVideo());
  }
}
